
import { defineComponent } from 'vue'
import AppTopBar from '@/components/AppTopBar.vue'
import AppNavigation from '@/components/AppNavigation.vue'
import { onBeforeRouteLeave } from 'vue-router'
import { useApp } from '@/composable/useApp'
import AppStatusbar from '@/components/AppStatusbar.vue'

export default defineComponent({
  name: 'LayoutDefault',

  components: {
    AppTopBar,
    AppNavigation,
    AppStatusbar,
  },

  setup() {
    const { showHeader } = useApp()
    // Reload page to get latest permission rules
    onBeforeRouteLeave((to) => {
      window.location.pathname = to.path
    })

    return {
      showHeader,
      statusbar,
    }
  },
})
